import { fetchCategory, getItems, GroupOrder } from "../../../ApiService/Apis/Items/Item";
import { fetchTable } from "../../../ApiService/Apis/Table/table";
import {
  buildSearchQuery,
  colors,
  getDecryptedValue,
  getLocalStorageItem,
  setLocalStorageItem,
  getImageUrl,
  Makelabel,
} from "../../../Utils/Index";
import React, { lazy, useEffect, useRef, useState } from "react";
import { Images } from "../../../Helper/Index";
import FoodOptionModal from "./FoodOptionModal";
import { GiFoodTruck } from "react-icons/gi";
import OrderListDrawer from "./OrderListDrawer";
import { ImageUrl } from "../../../ApiService/Axios/Index";
import { BsPatchCheckFill } from "react-icons/bs";
import { triggerSnackbar } from "../../../Services/NotificationService";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Input, message, Skeleton } from "antd";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { FaSearch } from "react-icons/fa";
import SingleOrGroup from "./SingleOrGroup";
import { CreateGroupOrder, fetchOrderGroupSummery } from "../../../ApiService/Apis/order/order";
import FoodGroupOptionModal from "./FoodGroupOptionModal";
import CommonInput from "../../../Components/CommonInput";
import CommonButton from "../../../Components/CommonButton";
const OrderDetailLeftPanel = lazy(() => import("./OrderDetailLeftPanel"));

const MakeOrderByCutomer = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const catRef = useRef(null);
  const [params] = useSearchParams();
  const [tableList, setTableList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [ApiCall, setApiCall] = useState(false);

  const [orderType, setOrderType] = useState(null); // "single" or "group"

  const [categoryList, setCategoryList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [OrderData, setOrderData] = useState();

  const [searchField, setSearchField] = useState(null);
  const [ItemsCurrent, setItemsCurrent] = useState(1);

  useEffect(() => {
    const type = params.get("orderType");
    if (type) {
      setOrderType(type);
    }
  }, [params]);

  const [itemsHasMore, setItemshasMore] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [openOptionModal, setOpenOptionModal] = useState(false);
  const [SelectedFoodDetail, setSelectedFoodDetail] = useState(null);
  const [otpData, setOtpData] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedTableNumber, setSelectedTableNo] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [orderedItems, setOrdereditems] = useState([]);
  const [openOrderListDrawer, setOpenOrderListDrawer] = useState(false);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showJoinGroupModal, setShowJoinGroupModal] = useState(false);
  const [joinGroupDetail, setJoinGroupDetail] = useState({
    customerName: "",
    mobileNumber: "",
  });
  const [joinGroupError, setJoinGroupError] = useState("");
  const sesionId = getLocalStorageItem("sessionId");
  const customerId = getLocalStorageItem("customerId");

  const getTables = () => {
    const param = {
      limit: 50,
      restaurantId: params.getAll("restaurantId")[0],
    };
    fetchTable(buildSearchQuery(param))
      .then((res) => {
        if (res.status === "success") {
          if (location.pathname?.includes("customer")) {
            setTableList(
              res.data.tables?.filter(
                (i) => i.id === Number(params.getAll("tableId")[0])
              )
            );
            setSelectedTable(Number(params.getAll("tableId")[0]));
            setSelectedTableNo(Number(params.getAll("tableNo")[0]));
          } else {
            setTableList(res.data.tables);
          }
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllItems = (page = ItemsCurrent, id = selectedCategory) => {
    const payload = {
      page: page,
      categoryId: id,
      limit: 12,
      search: searchField,
      restaurantId: Number(params.getAll("restaurantId")[0]),
    };
    getItems(buildSearchQuery(payload))
      .then((res) => {
        if (res.status) {
          setItemList(res.data?.foodItems);
          setItemshasMore(res.data?.nextPage);
        }
      })
      .catch((err) => console.log(err));
  };

  const clearGroupSession = () => {
    localStorage.removeItem("sessionId");
    localStorage.removeItem("customerId");
    setOrderData(null);
    setSummary(null);
    setShowJoinGroupModal(true); // prompt user to join again
  };

  const getAllItemsThroughLoadMore = (
    page = ItemsCurrent,
    id = selectedCategory
  ) => {
    setBtnLoader(true);
    const payload = {
      page: page,
      categoryId: id,
      search: searchField,
      restaurantId: Number(params.getAll("restaurantId")[0]),
    };
    getItems(buildSearchQuery(payload))
      .then((res) => {
        if (res.status) {
          setItemList([...itemList, ...res.data?.foodItems]);
          setItemshasMore(res.data?.nextPage);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoader(false));
  };
  useEffect(() => {
    getTables();
    getCategoryList();
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (!OrderData?.sessionId) return; // only call if sessionId is available
  //   setLoading(true);
  //   fetchOrderGroupSummery(OrderData?.sessionId)
  //     .then((res) => {
  //       setSummary(res?.data); // assuming API returns { data: {...} }
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching group summary:", err);
  //       setError("Failed to load order summary");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, [OrderData]);

  const getGroupSummary = () => {
    setLoading(true);
    fetchOrderGroupSummery(sesionId)
      .then((res) => {
        if (res.status) {
          const expiresAt = res?.data?.session?.expiresAt;
          // Proactive check: if expiry timestamp has already passed, clear session
          if (expiresAt && new Date(expiresAt).getTime() < Date.now()) {
            triggerSnackbar("Your group session has expired", "error");
            clearGroupSession();
            return;
          }
          setSummary(res?.data);
        } else {
          // Backend explicitly says session invalid/expired
          triggerSnackbar(res?.message || "Session expired", "error");
          clearGroupSession();
        }
      })
      .catch((err) => {
        console.error("Error fetching group summary:", err);
        setError("Failed to load order summary");
        // Treat fetch failure (e.g. 404/410 session-not-found) as expired too
        if (err?.response?.status === 404 || err?.response?.status === 410) {
          clearGroupSession();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleJoinGroupSubmit = () => {
    if (!joinGroupDetail.customerName.trim()) {
      setJoinGroupError("Customer name is required");
      return;
    }
    if (!joinGroupDetail.mobileNumber.trim() || joinGroupDetail.mobileNumber.length < 10) {
      setJoinGroupError("Enter a valid mobile number");
      return;
    }
    setJoinGroupError("");
    setShowJoinGroupModal(false);
    handleGroupOrderItem(joinGroupDetail.customerName, joinGroupDetail.mobileNumber);
  };
  const handleGroupOrderItem = (customerName, mobileNumber) => {
    // const formdata = new FormData();
    // formdata.append("restaurantId", Number(params.getAll("restaurantId")[0]));
    // formdata.append("tableId", Number(params.getAll("tableId")[0]));
    GroupOrder({
      "restaurantId": Number(params.getAll("restaurantId")[0]),
      "tableId": Number(params.getAll("tableId")[0]),
      "mobileNumber": mobileNumber,
      "customerName": customerName
    })
      .then((res) => {
        setOrderData(res?.data);
        setShowJoinGroupModal(false);
        message.success(res?.message);
        setLocalStorageItem("customerId", res?.data?.customerId);
        setLocalStorageItem("sessionId", res?.data?.sessionId);
        setLocalStorageItem("access_token", res?.data?.accessToken);
        setLocalStorageItem("restaurantId", res?.data?.restaurantId);
        setLocalStorageItem("role", res?.data?.role);
      })
      .catch((err) => console.log(err))
      .finally((data) => console.log(data));
  }


  useEffect(() => {
    const token = getLocalStorageItem("access_token");

    if (orderType === "group" && !token) {
      setShowJoinGroupModal(true);
    }
  }, [orderType]);

  useEffect(() => {
    let interval;
    if (orderType === "group" && sesionId && OrderData?.sessionId) {
      getGroupSummary(sesionId);
      interval = setInterval(() => {
        getGroupSummary(sesionId);
      }, 5000); // Poll every 5 seconds
    }
    return () => clearInterval(interval);
  }, [orderType, OrderData?.sessionId, sesionId]);

  useEffect(() => {
    getAllItemsThroughLoadMore();
  }, [ItemsCurrent]);

  useEffect(() => {
    getAllItems(1, selectedCategory);
    //eslint-disable-next-line
  }, [selectedCategory]);
  const getCategoryList = () => {
    const param = {
      restaurantId: params?.getAll("restaurantId")[0],
      limit: 500,
    };
    fetchCategory(buildSearchQuery(param))
      .then((res) => {
        if (res.status === "success") {
          setCategoryList([
            { id: null, categoryName: "All" },
            ...res.data.categories,
          ]);
        }
      })
      .catch((err) => console.log(err));
  };
  const scrollLeft = (from) => {
    if (from === "table") {
      if (tableRef.current) {
        tableRef.current.scrollBy({
          left: -200, // Adjust the scroll distance as needed
          behavior: "smooth", // Smooth scrolling
        });
      }
    } else {
      if (catRef.current) {
        catRef.current.scrollBy({
          left: -200, // Adjust the scroll distance as needed
          behavior: "smooth", // Smooth scrolling
        });
      }
    }
  };
  useEffect(() => {
    let delayDebounce;
    if (searchField !== "") {
      delayDebounce = setTimeout(() => {
        getAllItems(1);
      }, 500);
    } else {
      getAllItems(1);
      setItemsCurrent(1);
    }
    // Cleanup the timeout on query change
    return () => {
      clearTimeout(delayDebounce);
    };
    //eslint-disable-next-line
  }, [searchField]);
  const scrollRight = (from) => {
    if (from === "table") {
      if (tableRef.current) {
        tableRef.current.scrollBy({
          left: 200, // Adjust the scroll distance as needed
          behavior: "smooth", // Smooth scrolling
        });
      }
    } else {
      if (catRef.current) {
        catRef.current.scrollBy({
          left: 200, // Adjust the scroll distance as needed
          behavior: "smooth", // Smooth scrolling
        });
      }
    }
  };

  useEffect(() => {

    if (orderType == "group" && orderedItems.length > 0) {

      const payload = {
        tableId: selectedTable,
        items: orderedItems.map((i) => {
          return {
            foodId: i.foodId,
            foodVariant: i?.foodVariant,
            quantity: i.quantity,
          };
        })
      };

      const handlePlaceGroupOrder = (data) => {
        let temp = { ...payload };

        temp["customerId"] = OrderData?.customerId;
        temp["sessionId"] = OrderData?.sessionId;

        CreateGroupOrder(temp)
          .then((res) => {
            if (res.status === "success") {
              triggerSnackbar(res.message, "success");
              setBtnLoading(false);
              setApiCall(true)
              getGroupSummary(sesionId)

              if (location.pathname?.includes("customer")) {
                const token = getLocalStorageItem("access_token");

                if (token) {
                  navigate("/customer/current-order");
                } else {
                  setShowJoinGroupModal(true);
                }
              }
            }
          })
          .catch((err) => console.log(err))
          .finally(() => setBtnLoading(false));
      };
      //   handlePlaceGroupOrder();
    }

  }, [orderedItems])



  return (
    <>
      {showJoinGroupModal && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-dynmaicBg2 rounded-lg p-6 w-[90%] max-w-md">
            <h3 className="text-dynmaicText text-lg font-bold mb-4">
              Join Group Order
            </h3>

            <div className="mb-3">
              {Makelabel("Customer Name")}
              <CommonInput
                onChange={(e) =>
                  setJoinGroupDetail({
                    ...joinGroupDetail,
                    customerName: e.target.value,
                  })
                }
                value={joinGroupDetail.customerName}
                placeholder={"Enter your name"}
              />
            </div>

            <div className="mb-3">
              {Makelabel("Mobile Number")}
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  e.target.value = value;
                }}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setJoinGroupDetail({
                    ...joinGroupDetail,
                    mobileNumber: value,
                  });
                }}
                value={joinGroupDetail.mobileNumber}
                maxLength={10}
                placeholder={"Enter mobile number"}
              />
            </div>

            {joinGroupError && (
              <p className="text-red-400 text-sm mb-3">{joinGroupError}</p>
            )}

            <div className="flex justify-center gap-4 mt-4">
              <CommonButton
                onClick={() => setShowJoinGroupModal(false)}
                text={"Cancel"}
                color={colors.red}
              />
              <CommonButton
                onClick={handleJoinGroupSubmit}
                text={"Join"}
                color={colors.green}
              />
            </div>
          </div>
        </div>
      )}
      {!orderType ? (
        <SingleOrGroup />
      ) : (
        <>
          {location.pathname?.includes("customer") && (
            <>
              <div
                style={{ zIndex: "9999" }}
                className="bg-dynmaicBg w-full text-dynmaicText h-16 py-3 px-8 flex justify-between items-center"
              >
                <div className="flex justify-start items-center gap-8">
                  <p className="text-2xl font-inter font-bold">Restro</p>
                </div>

                {(sesionId || customerId) && (
                  <Button
                    type="primary"
                    style={{
                      background: colors.green,
                      borderColor: colors.green,
                    }}
                    onClick={() => {
                      const token = getLocalStorageItem("access_token");

                      if (orderType === "group" && !token) {
                        setShowJoinGroupModal(true);
                        return;
                      }

                      navigate("/customer/current-order");
                    }}
                  >
                    Check Order Status
                  </Button>
                )}
              </div>
            </>
          )}
          <div
            className={`grid grid-cols-8  place-items-center ${location.pathname?.includes("customer") &&
              "px-8  relative py-4  h-full min-h-screen"
              } gap-6 lg:mb-0`}
          >
            <div
              className={`lg:col-span-3 xl:col-span-2 hidden lg:block ${orderedItems.length > 0 ? "opacity-100" : "hidden lg:hidden"
                } bg-dynmaicBg3 rounded-md p-4 w-full h-[85vh] overflow-auto`}
            >
              <React.Suspense
                fallback={
                  <>
                    <Skeleton active className="mt-4" />
                    <Skeleton active className="mt-4" />
                    <Skeleton active className="mt-4" />
                    <Skeleton active className="mt-4" />
                  </>
                }
              >
                <OrderDetailLeftPanel
                  otpData={otpData}
                  setOpen={setOpenOrderListDrawer}
                  setOtpData={setOtpData}
                  setOpenOtpModal={setOpenOtpModal}
                  openOtpModal={openOtpModal}
                  ApiCall={ApiCall}
                  selectedTable={selectedTable}
                  selectedTableNumber={selectedTableNumber}
                  orderedItems={orderedItems}
                  orderType={orderType}
                  setOptionModal={setOpenOptionModal}
                  OrderData={OrderData}
                  summary={summary}
                  setOrdereditems={setOrdereditems}
                />
              </React.Suspense>
            </div>
            <div
              className={`col-span-8 ${orderedItems.length > 0
                ? "lg:col-span-5 xl:col-span-6"
                : "col-span-8"
                }  w-full h-full`}
            >
              <div className="flex lg:hidden justify-end items-center font-inter font-semibold cursor-pointer">
                <p
                  onClick={() => setOpenOrderListDrawer(true)}
                  className="text-dynmaicText flex justify-end items-center gap-2"
                >
                  <GiFoodTruck color={colors.green} size={25} /> Order List
                </p>
              </div>
              <>
                {!location.pathname?.includes("customer") && (
                  <>
                    <div className="flex flex-wrap gap-5 justify-between items-center mt-4">
                      <div className="flex justify-start items-center gap-8">
                        <p className="text-lg xl:text-2xl font-poppins font-bold text-dynmaicText">
                          Tables
                        </p>
                      </div>
                    </div>
                    {tableList.length > 0 ? (
                      <div className=" relative px-8   mt-4">
                        <div
                          ref={tableRef}
                          className="overflow-x-scroll flex justify-start  items-center gap-5"
                        >
                          {tableList.map((i, index) => {
                            return (
                              <div
                                onClick={() =>
                                  i.table_status === 1
                                    ? (setSelectedTable(i.id),
                                      setSelectedTableNo(i.table_no))
                                    : triggerSnackbar(
                                      "Already reserved 😢",
                                      "error"
                                    )
                                }
                                key={index}
                                className="relative  cursor-pointer"
                              >
                                <img
                                  className="cursor-pointer"
                                  src={
                                    i.table_status === 1
                                      ? Images.tablefree
                                      : Images.tableOccupied
                                  }
                                  alt="tableimage"
                                  style={{ width: "100px" }} // Adjust the width and height as needed
                                />
                                <p className="absolute top-10 left-12 text-dynmaicText font-bold font-inter text-xs ">
                                  {i.table_no}
                                </p>
                                {selectedTable === i.id && (
                                  <div className="absolute top-2 right-0">
                                    <BsPatchCheckFill
                                      size={25}
                                      color={colors.green}
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div
                          onClick={() => scrollLeft("table")}
                          className="absolute top-[30%] left-0 text-gray-500 cursor-pointer bg-dynmaicBg3 w-6 h-7 rounded-md p-1 flex justify-center items-center"
                        >
                          <HiChevronLeft size={45} />
                        </div>
                        <div
                          onClick={() => scrollRight("table")}
                          className="absolute  top-[30%] right-0 cursor-pointer  text-gray-500 bg-dynmaicBg3 w-6 h-7 rounded-md p-1 flex justify-center items-center"
                        >
                          <HiChevronRight />
                        </div>
                      </div>
                    ) : (
                      <p className="flex justify-center text-dynmaicText items-center font-bold text-lg mt-4 font-inter">
                        No Table found
                      </p>
                    )}
                  </>
                )}
              </>
              <div className="flex flex-wrap gap-5 justify-between items-center mt-4">
                <div className="flex justify-start items-center gap-8">
                  <p className="text-lg xl:text-2xl font-poppins font-bold text-dynmaicText">
                    Categories
                  </p>
                </div>
              </div>
              {categoryList?.length > 0 ? (
                <div className="relative px-8   mt-4">
                  <div
                    ref={catRef}
                    className="flex justify-start items-center overflow-x-scroll mt-6 gap-5"
                  >
                    {categoryList?.map((i, index) => {
                      return (
                        <div
                          onClick={() => {
                            selectedCategory !== i.id && setItemList([]);
                            setSelectedCategory(i.id);
                            setItemsCurrent(1);
                          }}
                          key={index}
                          className={`relative ${selectedCategory === i.id
                            ? "bg-brand text-dynmaicBg2"
                            : "bg-dynmaicBg3 text-dynmaicText"
                            } px-8 py-4 flex-shrink-0 h-full rounded-xl flex flex-col text-center justify-center items-center cursor-pointer`}
                        >
                          {/* <PiHamburgerThin
                        color={
                          selectedCategory === i.id ? "white" : colors.green
                        }
                      /> */}
                          <p className="text-center font-semibold font-inter text-xs capitalize ">
                            {i?.categoryName}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    onClick={() => scrollLeft("cat")}
                    className="absolute top-[30%] left-0 text-gray-500 cursor-pointer bg-dynmaicBg3 w-6 h-7 rounded-md p-1 flex justify-center items-center"
                  >
                    <HiChevronLeft />
                  </div>
                  <div
                    onClick={() => scrollRight("cat")}
                    className="absolute  top-[30%] right-0 cursor-pointer  text-gray-500 bg-dynmaicBg3 w-6 h-7 rounded-md p-1 flex justify-center items-center"
                  >
                    <HiChevronRight />
                  </div>
                </div>
              ) : (
                <p className="flex justify-center text-dynmaicText items-center text-xl font-bold mt-4 font-inter">
                  No Catgeory found
                </p>
              )}
              <div className="mt-4">
                <Input
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                  placeholder="Search Items"
                  className="bg-dynmaicBg3 h-10 text-dynmaicText border-none hover:bg-dynmaicBg3 hover:shadow-none focus:shadow-none shadow-none focus:bg-dynmaicBg3 rounded-full"
                  suffix={<FaSearch />}
                />
              </div>
              {itemList.length > 0 ? (
                <>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 place-items-center mt-6 gap-5">
                    {itemList?.map((i, index) => {
                      return (
                        <div
                          key={index}
                          className="relative bg-dynmaicBg3 w-full rounded-2xl cursor-pointer overflow-hidden shadow-lg hover:shadow-xl transition-shadow hover:scale-105 duration-300 flex flex-col border border-gray-700"
                        >
                          {/* Product Image */}
                          <div
                            className="w-full h-[180px] bg-gray-800 overflow-hidden"
                            style={{
                              backgroundImage: `url(${i?.foodImage?.length > 0
                                ? getImageUrl(i.foodImage[0])
                                : "https://suzlon.vtlabs.dev/web/images/2.png"
                                })`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                            }}
                          >
                            {/* Veg/Non-veg badge */}
                            <div className="p-2 flex justify-end">
                              <div
                                className={`w-7 h-7 border-2 flex justify-center items-center rounded-full ${i.is_veg === "1"
                                  ? "border-green-500 bg-green-100"
                                  : "border-red-500 bg-red-100"
                                  } `}
                              >
                                <div
                                  className={`w-2.5 h-2.5 rounded-full ${i.is_veg === "1" ? "bg-green-600" : "bg-red-600"
                                    }`}
                                ></div>
                              </div>
                            </div>
                          </div>

                          {/* Product Info */}
                          <div className="p-3 flex-1 flex flex-col">
                            {/* Product Name */}
                            <p className="text-dynmaicText font-semibold font-inter text-md capitalize line-clamp-1 mb-0">
                              {i?.name}
                            </p>
                            <p className="text-dynmaicText font-inter text-sm capitalize line-clamp-1 mb-3">
                              {i?.description}
                            </p>

                            {/* Price and Button Container */}
                            <div className="flex justify-between items-center gap-2 mt-auto">
                              <div className="bg-brand px-3 py-1.5 rounded-lg flex-shrink-0">
                                <p className="font-bold text-white font-inter text-sm">
                                  ₹ {i?.price}
                                </p>
                              </div>
                              <button
                                onClick={() => {
                                  if (
                                    selectedTable ||
                                    location.pathname?.includes("customer")
                                  ) {
                                    setSelectedFoodDetail(i);
                                    setOpenOptionModal(true);
                                  } else {
                                    triggerSnackbar(
                                      "Kindly select a table first",
                                      "error"
                                    );
                                  }
                                }}
                                className="bg-brand text-white px-3 py-1.5 rounded-lg font-semibold font-inter text-sm hover:bg-opacity-90 transition-all duration-200 flex-shrink-0"
                              >
                                + ADD
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : itemList.length <= 0 ? (
                <p className="flex justify-center text-dynmaicText items-center text-xl mt-20 font-bold  font-inter">
                  No Food Item Found
                </p>
              ) : (
                ""
              )}
              {itemsHasMore && (
                <div className="flex justify-center items-center mt-2">
                  <Button
                    loading={btnLoader}
                    onClick={() => setItemsCurrent(ItemsCurrent + 1)}
                    style={{ background: colors.green, color: "white" }}
                    className="text-dynmaicText rounded-none border-none px-4  mt-4 font-inter h-8"
                  >
                    Load More
                  </Button>
                </div>
              )}
            </div>
            {orderedItems.length > 0 && (
              <div
                onClick={() => setOpenOrderListDrawer(true)}
                className="w-[82%]  lg:hidden bg-brand text-white flex justify-between items-center font-semibold font-inter text-brand rounded-md px-4 py-2 fixed bottom-6"
              >
                <p>View Added Items</p>
                <p className="border border-white w-6 h-6 flex justify-center items-center rounded-full">
                  {orderedItems.length}
                </p>
              </div>
            )}
          </div>
        </>
      )}
      {orderType == "group" ?

        openOptionModal && (
          <FoodGroupOptionModal
            orderedItems={orderedItems}
            setOrdereditems={setOrdereditems}
            open={openOptionModal}
            setOpen={setOpenOptionModal}
            detail={SelectedFoodDetail}
          />
        )
        :

        openOptionModal && (
          <FoodOptionModal
            orderedItems={orderedItems}
            setOrdereditems={setOrdereditems}
            open={openOptionModal}
            setOpen={setOpenOptionModal}
            detail={SelectedFoodDetail}
          />
        )

      }

      {openOrderListDrawer && (
        <OrderListDrawer
          otpData={otpData}
          setOtpData={setOtpData}
          ApiCall={ApiCall}
          selectedTable={selectedTable}
          selectedTableNumber={selectedTableNumber}
          orderedItems={orderedItems}
          openOtpModal={openOtpModal}
          setOpenOtpModal={setOpenOtpModal}
          setOrdereditems={setOrdereditems}
          open={openOrderListDrawer}
          orderType={orderType}
          OrderData={OrderData}
          setOptionModal={setOpenOptionModal}
          handlePlaceGroupOrder={getGroupSummary}
          setOpen={setOpenOrderListDrawer}
        />
      )}
    </>
  );
};

export default MakeOrderByCutomer;
